import { SxProps } from '@mui/material';
import useAuth from '../../hooks/useAuth';
import AlertBanner from './AlertBanner';
import { SUSPENSION_SETTINGS } from '../../constants/common.constants';
import { getAcknowledgementConfig, getSuspensionReason } from '../../utils/suspension';

export default function SuspensionBanner({ sx }: { sx?: SxProps }) {
    const { user } = useAuth();

    const reason = getSuspensionReason(user);

    // Missed-session suspensions have their own dashboard banner
    if (!user || !reason || getAcknowledgementConfig(reason)) return <></>;

    const alert = SUSPENSION_SETTINGS[reason]?.alert(user);

    // Conditional render
    if (!alert) return <></>;

    return (
        <AlertBanner
            sx={{
                backgroundColor: 'rgb(255, 0, 0)',
                width: '100%',
                flexGrow: 2,
                mb: 0,
                ...sx,
            }}
        >
            {alert}
        </AlertBanner>
    );
}
